import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AgendaService } from '../../agenda.service';
import { Subscription } from 'rxjs';
import { UtilsProvider } from '../../../common/providers/utils-provider.service';
import {NgForOf, NgIf} from "@angular/common";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";
import { AppDatePipe } from "../../../common/pipes/app-date";

@Component({
  selector: 'agendas-week-selector',
  providers: [],
  styleUrls: ['./week-selector.scss'],
  standalone: true,
  imports: [
    NgForOf,
    MatIconButton,
    MatButton,
    MatMenuItem,
    MatMenuTrigger,
    MatMenu,
    MatIcon,
    AppDatePipe,
    TranslateModule,
    AppDatePipe,
    NgIf,
  ],
  templateUrl: './week-selector.html'
})
export class AgendasWeekSelectorComponent implements AfterViewInit {
    @Input() public set date(date: Date) {
        // Check if date is invalid and use today as fallback
        if (!date || isNaN(date.getTime())) {
            this._date = new Date();
        } else {
            this._date = date;
        }
        this.updateFromToDates();
        this.updateYearMenu();
    }
    public get date() {
        return this._date ?? new Date();
    }
    @Input() public beforeDateChangeHook$: any = null;

    public fromDate: Date  | null= null;
    public toDate: Date | null = null;
    public todayWeekDate: Date = this.utils.firstDayOfWeek(new Date());

    public year = 0;
    public yearWeeks: any[] = [];
    private _date: Date | null= null;

    private subscription: Subscription = new Subscription();
    constructor(
        public utils: UtilsProvider,
        public translater: TranslateService,
        private agendaService: AgendaService
    ) {
        this.date = new Date();
    }

    public ngAfterViewInit() {
    }

    public async onChangeClicked(weekDiff: number): Promise<void> {
        const newDate: Date = new Date(this._date!);
        newDate.setDate(this._date!.getDate() + (weekDiff * 7));

        if (this.beforeDateChangeHook$ && !(await this.beforeDateChangeHook$(this._date, newDate))) {
            return;
        }

        this.date = newDate;
        this.agendaService.emitDateChanged(this.date);

        // this.dateChange.emit(this.date);
    }

    public async onSelectWeek(date: Date): Promise<void> {
        if (this.beforeDateChangeHook$ && !(await this.beforeDateChangeHook$(this._date, date))) {
            return;
        }

        this.date = date;
        this.agendaService.emitDateChanged(this.date);

        // this.dateChange.emit(this.date);
    }

    public onChangeYearClicked(event: any, yearDiff: number): void {
        event.stopPropagation();
        this.updateYearMenu(this.year + yearDiff);
    }

    public updateYearMenu(year: number |null = null): void {
        if (!this._date) {
            return;
        }

        this.year = year ? year : this.date.getFullYear();
        const date: Date = new Date(this.year, 0, 1);
        const toDate: Date = new Date(date.getFullYear() + 1, 0, 1);
        const yearWeeks: any[] = [];
        while (date.getTime() < toDate.getTime()) {
            yearWeeks.push({
                fromDate: this.utils.firstDayOfWeek(date),
                toDate: this.utils.lastDayOfWeek(date)
            });

            date.setDate(date.getDate() + 7);
        }

        this.yearWeeks = yearWeeks;
    }

    private updateFromToDates(): void {
        if (!this._date) {
            this.fromDate = null;
            this.toDate = null;
            return;
        }
        this.fromDate = this.utils.firstDayOfWeek(this._date);
        this.toDate = this.utils.lastDayOfWeek(this._date);
    }
}
